import { render, staticRenderFns } from "./SetupConnectionModal.vue?vue&type=template&id=29c8815e&scoped=true"
import script from "./SetupConnectionModal.vue?vue&type=script&lang=js"
export * from "./SetupConnectionModal.vue?vue&type=script&lang=js"
import style0 from "./SetupConnectionModal.vue?vue&type=style&index=0&id=29c8815e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c8815e",
  null
  
)

export default component.exports